import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';

import { associateCandidatesSuccess } from '@modules/assigns/store/assigns.actions';
import { Association } from '@shared/models';

import {
  associationRemove,
  associationsGetListSuccess,
  associationsLoadSuccess,
  associationsPatchSuccess,
  collectionAssociationsClear,
} from './associations.actions';

export type AssociationsState = EntityState<Association>;

export const associationsAdapter: EntityAdapter<Association> = createEntityAdapter<Association>({});

export const initialState: AssociationsState = associationsAdapter.getInitialState({});

const reducer = createReducer(
  initialState,
  on(associationsGetListSuccess, (state, { associations }) =>
    associationsAdapter.upsertMany(associations, state),
  ),
  on(associationsLoadSuccess, (state, { associationPage: { content } }) =>
    associationsAdapter.upsertMany(content, state),
  ),
  on(associationsPatchSuccess, (state, { association }) =>
    associationsAdapter.upsertOne(association, state),
  ),
  on(associateCandidatesSuccess, (state, { associations }) =>
    associationsAdapter.upsertMany(associations, state),
  ),
  on(associationRemove, (state, { id }) => associationsAdapter.removeOne(id, state)),
  on(collectionAssociationsClear, (state) => associationsAdapter.removeAll({ ...state })),
);

export function associationsReducer(state: AssociationsState, action) {
  return reducer(state, action);
}
